import React from "react";

const DumbBadge = ({ children, variant = "primary", title = "" }) => (
  <div
    className={`bg-${variant} text-white text-sm font-bold mx-2 rounded-full inline-block w-6 h-6 text-center uppercase whitespace-nowrap`}
    title={title}
    style={{ lineHeight: "1.5rem" }}
  >
    {children}
  </div>
);

const AgencyBadge = ({ isCompanyAgencyDeal = false }) => (
  <DumbBadge variant={'blue-light'} title={"Agency"}>A{isCompanyAgencyDeal ? '*' : ''}</DumbBadge>
);

const CompanyBadge = ({ isCompanyAgencyDeal = false }) => (
  <DumbBadge title={"Company"}>C{isCompanyAgencyDeal ? '*' : ''}</DumbBadge>
);

const EDGEPlatformBadge = () => (
  <DumbBadge variant="brand" title={"EDGE Platform"}>E</DumbBadge>
);
export {DumbBadge, AgencyBadge, CompanyBadge, EDGEPlatformBadge};
